import { FunctionComponent, useState } from "react";
import VideoModal from "../VideoModal";
import HomeVideoComponent from "../HomeVideoComponent";

const HomeVideo: FunctionComponent = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <HomeVideoComponent openModal={handleOpenModal} />
      {openModal && <VideoModal closeModal={handleCloseModal} />}
    </>
  );
};

export default HomeVideo;
